export default () => ({
  data: null,
  batch: null,
  timeline: null,
  previousChecks: null,
  image: null
})
